module.exports = "/_next/static/images/Winegard-ac8398fdffb9bb153de425720ac95575.png";